module.exports = __webpack_public_path__ + "img/social-icon-linkedin.8f7746c1.svg";